<template>
  <div class="login-page">
    <nav class="navbar navbar-transparent navbar-absolute">
      <div class="container">
        <div class="img-wrapper">
          <router-link :to="{ name: 'home' }">
            <img :src="companyLogo" alt="company logo" />
          </router-link>
        </div>
        <!-- </div> -->
      </div>
    </nav>

    <div class="wrapper wrapper-full-page">
      <div class="full-page" :data-image="fullPageBackground">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-md-4 col-sm-6 col-md-offset-4 col-sm-offset-3">
                <error-listener />
                <form ref="form" @submit="logUser">
                  <div class="card" data-background="color" data-color="blue">
                    <div class="card-header">
                      <h3 class="card-title">Login</h3>
                    </div>
                    <div class="card-content">
                      <div class="form-group">
                        <label>Username</label>
                        <input
                          placeholder="Enter Username"
                          required
                          type="email"
                          class="form-control input-no-border"
                        />
                      </div>
                      <div class="form-group">
                        <label>Password</label>
                        <input
                          type="password"
                          placeholder="Password"
                          required
                          class="form-control input-no-border"
                        />
                      </div>
                    </div>
                    <div class="card-footer text-center">
                      <button
                        type="submit"
                        class="btn btn-fill btn-wd submit-button"
                        :class="{ loading: $wait.waiting(_uid) }"
                      >
                        Submit
                        <i
                          v-show="$wait.waiting(_uid)"
                          class="fas fa-circle-notch loading-icon"
                        />
                      </button>
                      <div class="forgot mt-xxs">
                        <router-link
                          :to="{ name: 'system@resetPassword' }"
                          class="text-primary text-2xl"
                        >
                          Forgot your password?
                        </router-link>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <footer class="footer footer-transparent">
          <div class="container">
            <div class="copyright">
              <span
                >&copy; 2006 - {{ year }} {{ reservedRightsWebSite }} All Rights
                Reserved.</span
              >
              <p>{{ getRevision() }}</p>
            </div>
          </div>
        </footer>
        <div
          class="full-page-background"
          :style="`background-image: url(${fullPageBackground})`"
        />
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import swal from "sweetalert2";
import label from "@/consts/label";
import { getStorageData, removeStorageData } from "@/utils/storage";
import { mapGetters, mapActions } from "vuex";
import ErrorListener from "@/components/UIComponents/ErrorListener/ErrorListener";

export default {
  components: {
    ErrorListener,
  },
  data() {
    const iframeLink = "https://admin.trainingport.net/terms";

    return {
      fullPageBackground: "static/img/background/login-page-background.jpg",
      iframeLink,
      year: moment().year(),
      companyLogo: label.companyLogo,
      reservedRightsWebSite: label.reservedRightsWebSite,
    };
  },
  computed: {
    ...mapGetters("loadingStore", { isLoading: "loading" }),
    ...mapGetters("userStore", ["user"]),
  },
  mounted() {
    this.logoutUser();
  },
  methods: {
    ...mapActions("loadingStore", ["setLoading"]),
    ...mapActions("errorStore", ["addNewError"]),
    ...mapActions("userStore", ["loginUser", "logoutUser"]),
    async showTermsAndConditions() {
      try {
        await swal({
          title: "Terms and Conditions",
          buttonsStyling: false,
          reverseButtons: true,
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonClass: "btn ml-xs btn-success btn-fill",
          confirmButtonText: "Accept",
          showCancelButton: true,
          cancelButtonText: "Decline",
          html: `<iframe class="term" src="${this.iframeLink}"/>`,
        });

        const intended = getStorageData("intended");
        removeStorageData("intended");

        const redirect = getStorageData("redirect");
        removeStorageData("redirect");

        if (redirect) {
          return window.location.replace(redirect.redirect_to);
        }

        const homeRoute = { name: "home" };
        const pushToRoute = intended || homeRoute;
        this.$router.push(pushToRoute);
        return;
      } catch (error) {
        // console.log("User didnt accepted the Terms and Conditions");
        return removeStorageData("redirect");
      }
    },
    async logUser(event) {
      event.preventDefault();
      const [inputEmail, inputPass] = this.$refs.form;
      const [email, pass] = [inputEmail.value, inputPass.value];

      if (!email || !pass) {
        return;
      }

      try {
        this.$wait.start(this._uid);
        await this.loginUser({
          userData: {
            username: inputEmail.value,
            password: inputPass.value,
          },
        });

        await this.showTermsAndConditions();
      } catch (error) {
        this.addNewError(error);
      } finally {
        this.$wait.end(this._uid);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.swal2-modal {
  width: 700px !important;
}

.term {
  width: 100%;
  min-height: 57vh;
}

.full-page > .content {
  min-height: calc(100vh - 122px);
}

@media (max-width: 992px) and (orientation: landscape) {
  .login-page {
    .full-page .content {
      padding-top: 90px;
      min-height: auto;
    }
    .navbar .img-wrapper {
      margin-top: 0px;
      img {
        width: 370px;
      }
    }
  }
}

@media (max-width: 1024px) and (orientation: portrait) {
  .login-page {
    .full-page .content {
      min-height: auto;
    }
  }
}
</style>
